
<div class="header-toolbar">
  <h1>Paramètres</h1>
</div>

<div class="settings">
  <a class="item" routerLink="/settings/users">
    <t-icon name="people"></t-icon>
    <div class="text">Utilisateurs</div>
  </a>
</div>